// extracted by mini-css-extract-plugin
export default {"priceCard":"Pricing_priceCard__QKnUA","active":"Pricing_active__GSI8J","largeMargin":"Pricing_largeMargin__V41Iy"};